var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',_vm._g(_vm._b({attrs:{"value":_vm.value,"max":_vm.safeMax,"picker-date":_vm.pickerDate},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)},'v-date-picker',_vm.$attrs,false),_vm.pickerListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }